export default {  
  state: {
    count: 0,
    torax: 75,
    cintura: 66,
    quadril: 87,
    gancho: 122,
    tabela: TabelaMoldes,
    lista_csv:[],
    resultado_total:[],
    index_ativo_lista:null
  },
  mutations: {
    alterartabela(state){

    },
    ALTERAR_LISTA_CSV(state, dados){
      state.lista_csv = dados
    },
    ALTERAR_LISTA_CSV_MOLDE_MANUAL(state, dados){
      state.lista_csv[dados[0]].molde_manual = dados[1]

    },
    ALTERAR_LISTA_CSV_MOLDE_ESPECIAL(state, dados){
      state.lista_csv[dados[0]].molde_especial = dados[1]
    },
    ALTERAR_RESULTADO_TOTAL(state, dados){
      state.resultado_total = dados
    },
    ATUALIZAR_TORAX(state, dados){
      state.torax = dados
    },
    ATUALIZAR_CINTURA(state, dados){
      state.cintura = dados
    },
    ATUALIZAR_QUADRIL(state, dados){
      state.quadril = dados
    },
    ATUALIZAR_GANCHO(state, dados){
      state.gancho = dados
    },
     ITEM_LISTA_ATIVO(state, dados){
      
      state.index_ativo_lista = dados
    },
    ADD_OBSERVACAO(state, dados){
      
      state.lista_csv[dados.index].observacao = dados.obs
    }
  },
  strict: true,
};


// WEBPACK FOOTER //
// ./src/vuex/store/store.js